import { MessageSquare } from "lucide-react";
import "./CustomRippleButton.css";

export default function CustomRippleButton({
  children,
  onClick,
  tooltip = "Open Chat",
  showLabel = false,
}) {
  const handleClick = (e) => {
    const btn = e.currentTarget;
    const ripple = document.createElement("span");
    const rect = btn.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    ripple.className = "ripple";
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;

    btn.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);

    onClick?.(e);
  };

  return (
    <button className="custom-ripple-btn hover:text-blue-700 hover:bg-blue-100 px-2 py-1" onClick={handleClick}>
      <span className="tooltip">{tooltip}</span>
      <span className="content">
        {children}
        {showLabel && <span className="label">Open Chat</span>}
      </span>
      <span className="hover-icon">
        <MessageSquare size={16} />
      </span>
    </button>
  );
}
